<template>
  <div class=''>
    <el-form class="content_block">
      <el-row>
        <el-col :span='24'>
          <el-form-item label="渠道名称：" >
            {{JZChannelPersonInfo.name}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span='24'>
          <el-form-item label="推广链接：" >
            {{JZChannelPersonInfo.url}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span='24'>
          <el-form-item label="二维码：" >
            <el-image :preview-src-list = '[JZChannelPersonInfo.qrCode]' fit="fill"  style="width: 80px; height: 80px;vertical-align: top;margin-right:10px;border-radius:5px;border:1px solid #efefef;" :src='JZChannelPersonInfo.qrCode' ></el-image>
            <el-link icon='el-icon-download' v-auth="'saas_promotionList:download'" @click="handleDown(JZChannelPersonInfo.qrCode,`${JZChannelPersonInfo.name}二维码`)" type="primary">下载二维码</el-link>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <table-with-pagination
      :tableData="targetLists"
      class="content_block"
      ref='JZChannelPersonTable'
      :columnList="columnList"
      :pagination.sync="pagination"
      :sortInfo.sync="updateSortInfo"
      @size-change="getTargetLists"
      @current-change="getTargetLists"
      @sort-change="getTargetLists"
      :checkbox-config="{reserve:true}"
      @selection-change="handleSelectionChange"
      :leftToolbar="tableButtons"
    ></table-with-pagination>
    <el-dialog
      title="新增推荐人"
      :visible.sync="isShow"
      width="400px"
      :append-to-body='true'
      :destroyOnClose='true'
      :close-on-click-modal='false'
    >
    <div class="content" style="max-height: 400px;overflow: auto;">
      <el-form
        :model="JZChannelPersonForm"
        ref="JZChannelPersonForm"
        :rules="JZChannelPersonFormRules"
        :inline="true"
        class="content_block"
        label-width="125px"
      >
        <el-row >
          <el-col :span="24">
            <el-form-item
                prop="name"
                label="推荐人名称："
              >
              <el-input v-model.trim="JZChannelPersonForm.name" placeholder="请输入推荐人名称" maxlength='20' show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer " style="text-align:right;" >
        <el-button @click="isShow=false" size="mini">取 消</el-button>
        <el-button type="primary" @click="handleEnsure" size="mini">确定</el-button>
    </span>
  </el-dialog>
  <BottomPanel>
    <el-button type="default" size="mini" @click="$router.go(-1)">取消</el-button>
  </BottomPanel>
</div>
</template>

<script>
import Promotion from '@/api/promotion';
import { TablePaginationMixin } from '@/components/common/TableWithPagination';
export default {
  name: 'PromotionDetail',
  mixins: [
    TablePaginationMixin,
  ],
  methods: {
    handleEnsure () {
      this.$refs.JZChannelPersonForm.validate((valid) => {
        if (valid) {
          Promotion.addChannelPerson(this.JZChannelPersonForm).then(() => {
            this.isShow = false;
            this.handleSearch();
          });
        }
      });
    },
    getDeatailInfo () {
      Promotion.detailChannel({id: this.$route.query.id}).then(res => {
        this.JZChannelPersonInfo = res.body;
      });
    },
    handleSearch () {
      this.pagination.currentPage = 1;
      this.getTargetLists();
    },
    getTargetLists () {
      Promotion.getChannelPersonLists({channelId: this.$route.query.id, pageSize: this.pagination.pageSize, pageNum: this.pagination.currentPage }).then(res => {
        let currentLists = [];
        currentLists = res.body.list || [];
        this.targetLists = currentLists.map(item=>{
          return {
            ...item,
            isStatus: false,
          };
        });
        this.pagination.total = res.body.total;
      });
    },
    handleSelectionChange (currentLists) {
      this.selectedLists = currentLists;
    },
    handleBatchUpdateStatusChannelPerson (status) {
      let idList = this.selectedLists.map(item => item.id);
      let title = status === '1' ? '批量启用' : '批量禁用';
      let content = status === '1' ? '' : '<br/>禁用后,当前选中的所有推荐人将不计入推广费，请慎用！！！';
      let message = `确认${title}选中的【${idList.length}】个推荐人吗？${content}`;
      this.$confirm(message, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true, // 允许确认框内容为html格式
        callback: action => {
          if (action === 'confirm') {
            Promotion.updateStatusChannelPerson({idList, status}).then(() => {
              this.selectedLists = [];
              this.$refs.JZChannelPersonTable.clearCheckboxRow();
              this.handleSearch();
            });
          }
        },
      });
    },
    handleUpdateStatusChannelPerson (info, status) {
      let title = status === '1' ? '启用' : '禁用';
      let content = status === '1' ? '' : '<br/>禁用后,当前推荐人将不计入推广费，请慎用！！！';
      let message = `确认${title}【${info.name}】推荐人吗？${content}`;
      this.$confirm(message, title, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true, // 允许确认框内容为html格式
        callback: action => {
          if (action === 'confirm') {
            Promotion.updateStatusChannelPerson({idList: [info.id], status: status}).then(() => {
              this.handleSearch();
            });
          }
        },
      });
    },
    handleEdit (row, index) {
      this.targetLists.splice(index, 1, {
        ...row,
        newName: row.name,
        isStatus: true,
      });
    },
    handleSave (row) {
      Promotion.updateChannelPerson({id: row.id, name: row.newName}).then(() => {
        this.handleSearch();
      });
    },
    handleCancel (row, index) {
      this.targetLists.splice(index, 1, {
        ...row,
        isStatus: false,
      });
    },
    handleDown (imgsrc, name) {
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous');
      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL('image/png'); // 得到图片的base64编码数据
        var a = document.createElement('a'); // 生成一个a元素
        var event = new MouseEvent('click'); // 创建一个单击事件
        a.download = name || '二维码'; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
  },
  created () {
    this.getDeatailInfo();
    this.handleSearch();
  },
  computed: {
    currentIdLists () {
      return this.targetLists.map(item => item.id);
    },
    tableButtons () {
      let currentLists = [
        {
          name: '新增推荐人',
          status: 'primary',
          size: 'small',
          code: 'addNewChannelPerson',
          icon: 'vxe-icon--plus',
          permission: 'saas_promotionChannel:add',
          click: ()=> {
            this.JZChannelPersonForm = {
              name: '',
              channelId: this.$route.query.id,
            };
            this.isShow = true;
          },
        },
        {
          name: '批量启用',
          status: 'primary',
          size: 'small',
          code: 'batchEnable',
          icon: '',
          disabled: !this.selectedLists.length,
          permission: 'saas_promotionChannel:batchEnable',
          click: () => { this.handleBatchUpdateStatusChannelPerson('1'); },
        },
        {
          name: '批量禁用',
          status: 'primary',
          size: 'small',
          code: 'batchDisable',
          icon: '',
          permission: 'saas_promotionChannel:batchDisable',
          disabled: !this.selectedLists.length,
          click: () => { this.handleBatchUpdateStatusChannelPerson('2'); },
        },
      ];
      return currentLists;
    },
  },
  data () {
    return {
      JZChannelPersonInfo: {},
      JZChannelPersonForm: {
        name: '',
        channelId: '',
      },
      JZChannelPersonFormRules: {
        name: [
          {
            required: true,
            message: '请输入推荐人名称',
            trigger: ['blur', 'change'],
          },
        ],
      },
      isShow: false,
      targetLists: [],
      selectedLists: [],
      columnList: [
        {
          tooltip: true,
          label: '全选',
          minWidth: '150px',
          type: 'checkbox',
          fixed: 'left',
        },
        {
          tooltip: true,
          label: '推荐人编码',
          minWidth: '160px',
          prop: 'code',
        },
        {
          tooltip: true,
          label: '推荐人姓名',
          minWidth: '150px',
          prop: 'name',
          render: (h, {row}) => {
            if (row.isStatus) {
              return h('el-input', {
                props: {
                  size: 'small',
                  value: row.newName,
                  showWordLimit: true,
                },
                attrs: {
                  maxlength: 20,
                },
                on: {
                  input: val => { row.newName = val; },
                },
              });
            } else {
              return h('span', row.name);
            }
          },
        },
        {
          tooltip: true,
          label: '推广链接',
          minWidth: '150px',
          prop: 'url',
        },
        {
          tooltip: true,
          label: '二维码',
          minWidth: '150px',
          prop: 'qrCode',
          render: (h, {row}) => {
            return <div><el-image preview-src-list={[row.qrCode]} style={'width:40px;height:40px;vertical-align: middle;margin-right:10px'} src={row.qrCode} ></el-image><el-link type={'primary'} v-auth={'saas_promotionList:download'} icon={'el-icon-download'} onClick={this.handleDown.bind(this, row.qrCode, `${row.name}二维码`)}>下载</el-link></div>;
          },
        },
        {
          tooltip: true,
          label: '创建人',
          minWidth: '150px',
          prop: 'createUserName',
        },
        {
          tooltip: true,
          label: '创建时间',
          minWidth: '150px',
          prop: 'createTime',
          format: this.$options.filters['date-format'],
        },
        {
          tooltip: true,
          label: '状态',
          minWidth: '150px',
          prop: 'statusDesc',
        },
        {
          label: '操作',
          minWidth: '180px',
          fixed: 'right',
          render: (h, {row, index}) => {
            let actions = [];
            if (row.status === '1') {
              actions.push(<span class="table-action" v-auth={'saas_promotionChannel:disable'} onClick={this.handleUpdateStatusChannelPerson.bind(this, row, '2')}>禁用</span>);
              if (row.isStatus) {
                actions.push(<span class="table-action" v-auth={'saas_promotionChannel:edit'} onClick={this.handleSave.bind(this, row)}>保存</span>);
                actions.push(<span class="table-action" v-auth={'saas_promotionChannel:edit'} onClick={this.handleCancel.bind(this, row, index)}>取消</span>);
              } else {
                actions.push(<span class="table-action" v-auth={'saas_promotionChannel:edit'} onClick={this.handleEdit.bind(this, row, index)}>编辑</span>);
              }
            } else if (row.status === '2') {
              actions.push(<span class="table-action" v-auth={'saas_promotionChannel:enable'} onClick={this.handleUpdateStatusChannelPerson.bind(this, row, '1')}>启用</span>);
            }
            return <div>{...actions}</div>;
          },
        },
      ],
    };
  },
};
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
/deep/ .el-dialog .el-dialog__header{
    border-bottom: 1px solid #efefef;
}
/deep/ .el-dialog .el-dialog__footer{
    border-top: 1px solid #efefef;
}
</style>
